module.exports = __webpack_public_path__ + "img/infinity8.cc7d24f1.jpg";